import React, { Fragment } from 'react';

import {
  StyledInputContainer,
  StyledLabelP,
  StyledPasswordLabelP,
  StyledActionsContainer,
  StyledButton,
  ButtonContainerStyled,
  StyledLinkButton,
} from 'helpers/StyledLoginComponentsHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { formatPhone } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';
import ReactPhoneInput from 'components/shared/ReactPhoneInput';
import FormHelperText from '@material-ui/core/FormHelperText';
import { colors } from 'helpers/ColorHelper';

export default props => {
  const { details, loginErrorData, handleInputChange, handleVerifyNumber } = props;
  const [isEditingMobile, setIsEditingMobile] = React.useState(false);
  return (
    <Fragment>
      <StyledInputContainer>
        <StyledLabelP mobile={props.mobile}>
          {getTranslatedString('login.verifyMobileNumber')}{' '}
          <strong>{formatPhone(loginErrorData.mobileNumber)}</strong>
        </StyledLabelP>

        {isEditingMobile && (
          <Fragment>
            <StyledPasswordLabelP>
              {getTranslatedString('login.editMobileNumber')}
            </StyledPasswordLabelP>

            <ReactPhoneInput
              name="mobileNumber"
              value={details.mobileNumber}
              onChange={handleInputChange}
            />
          </Fragment>
        )}
      </StyledInputContainer>
      {details.mobileNumberInputErrors.required && (
        <FormHelperText
          style={{
            color: colors.RED,
            position: 'relative',
            left: '10px',
            top: '5px',
          }}
        >
          {details.mobileNumberInputErrors.required}
        </FormHelperText>
      )}
      {details.mobileNumberInputErrors.validPhone && (
        <FormHelperText
          style={{
            color: colors.RED,
            position: 'relative',
            left: '10px',
            top: '5px',
          }}
        >
          {details.mobileNumberInputErrors.validPhone}
        </FormHelperText>
      )}
      <StyledActionsContainer mobile={props.mobile}>
        <ButtonContainerStyled mobile={props.mobile}>
          <StyledButton
            name="submit"
            inputProps={{
              'aria-label': getTranslatedString('login.verifyMobileNumberLabel'),
            }}
            data-testid="login-button"
            id={'login-button'}
            primary={true}
            onClick={handleVerifyNumber}
            accentColor={AccentColor()}
            disabled={!details.isButtonEnabled}
            labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
            mobile={props.mobile}
          >
            {getTranslatedString('login.verifyMobileNumberLabel')}
          </StyledButton>
        </ButtonContainerStyled>
        {!isEditingMobile && (
          <ButtonContainerStyled mobile={props.mobile}>
            <StyledLinkButton mobile={props.mobile} onClick={() => setIsEditingMobile(true)}>
              {getTranslatedString('login.editMobileNumber')}
            </StyledLinkButton>
          </ButtonContainerStyled>
        )}
      </StyledActionsContainer>
    </Fragment>
  );
};
